import styled from "styled-components";
import { colors } from "@pepdirect/v3/styles/variables";
import { ExternalLink } from "@pepdirect/v3/ui/ExternalLink";

export const StyledLegalCopy = styled.div`
  display: flex;
  flex-direction: column;
  color: ${colors.gray600};
  font-size: 13px;
  padding-top: 40px;
  margin-bottom: 4px;
  gap: 10px;
`;

export const StyledExternalLink = styled(ExternalLink)`
  color: ${({ theme }) => theme.color.primary};
`;
